/* Fransk katalog for locale-support-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'nav.support': 'Support',
  'navhelp.support': 'Consultez et suivez les demandes de support que vous avez envoyées.',
  'route.support': 'Support',
  'support.title': 'Support',
  'support.contact': 'Contacter le support',
  'support.close': 'Fermer',
  'support.send': 'Envoyer',
  'support.sending': 'Envoi…',
  'support.editor.toolbar': 'Mise en forme du message',
  'support.editor.bold': 'Gras',
  'support.editor.italic': 'Italique',
  'support.editor.underline': 'Souligné',
  'support.editor.bullets': 'Liste à puces',
  'support.editor.numbered': 'Liste numérotée',
  'support.editor.list': 'Liste',
  'support.editor.link': 'Lien',
  'support.editor.linkPrompt': 'Collez un lien http:// ou https://',
  'support.editor.image': 'Image',
  'support.editor.screenshot': 'Capture d\'écran',
  'support.editor.screenshotLabel': 'Joindre une capture d\'écran de la vue actuelle',
  'support.editor.capturing': 'Capture d\'écran en cours…',
  'support.editor.pendingImages': 'Images prêtes à être envoyées',
  'support.editor.removeImage': 'Retirer l\'image',
  'support.editor.openImage': 'Ouvrir l\'image',
  'support.editor.optimizing': 'Optimisation des images…',
  'support.retry': 'Réessayer',
  'support.back': 'Retour aux demandes de support',
  'support.category': 'Catégorie',
  'support.category.feil': 'Bug / quelque chose ne fonctionne pas',
  'support.category.fakturering': 'Facturation et paiement',
  'support.category.sporsmal': 'Question générale',
  'support.category.annet': 'Autre',
  'support.subject': 'Objet',
  'support.subject.placeholder': 'Brève description de la demande',
  'support.message': 'Message',
  'support.message.placeholder': 'Décrivez ce qui se passe, de préférence avec des détails',
  'support.sent.title': 'La demande de support a été envoyée',
  'support.sent.text': 'Nous avons bien reçu {id} et reviendrons vers vous dès que possible.',
  'support.new.title': 'Nouvelle demande de support',
  'support.new.action': 'Nouvelle demande',
  'support.filter.label': 'Filtrer les demandes de support',
  'support.filter.all': 'Toutes',
  'support.filter.open': 'Ouvertes',
  'support.filter.closed': 'Fermées',
  'support.table.ticket': 'Demande',
  'support.table.category': 'Catégorie',
  'support.table.sent': 'Envoyée',
  'support.table.lastReply': 'Dernière réponse',
  'support.lastReply.you': 'Vous',
  'support.lastReply.support': 'Support',
  'support.table.status': 'Statut',
  'support.status.open': 'Ouverte',
  'support.status.closed': 'Fermée',
  'support.opened': 'Ouverte le {date}',
  'support.closeTicket': 'Marquer comme fermée',
  'support.table.actions': 'Actions',
  'support.delete.rowAction': 'Supprimer',
  'support.delete.rowLabel': 'Supprimer la demande {{id}}',
  'support.delete.action': 'Supprimer la demande',
  'support.delete.title': 'Supprimer la demande ?',
  'support.delete.confirm': 'Supprimer',
  'support.delete.text': 'La demande sera retirée de votre liste et ses messages ne vous seront plus accessibles.',
  'support.delete.done': 'La demande a été supprimée.',
  'support.error.delete': 'La demande n\'a pas pu être supprimée. Réessayez.',
  'support.reopen.action': 'Rouvrir',
  'support.reopen.title': 'Rouvrir la demande de support ?',
  'support.reopen.confirm': 'Rouvrir quand même',
  'support.reopen.text': 'Ne rouvrez la demande que s\'il s\'agit du même problème qu\'à l\'origine. S\'il s\'agit d\'un nouveau problème, créez plutôt une nouvelle demande de support.',
  'support.you': 'Vous',
  'support.agent': 'Support',
  'support.reply.placeholder': 'Poursuivez la conversation – écrivez un message au support',
  'support.closed.note': 'Cette demande est fermée. Vous pouvez consulter l\'historique, mais pas envoyer d\'autres messages.',
  'support.empty.title': 'Aucune demande de support pour l\'instant',
  'support.empty.filterTitle': 'Aucune demande dans ce filtre',
  'support.empty.text': 'Les demandes que vous envoyez via le bouton de support apparaîtront ici.',
  'support.loading.list': 'Chargement des demandes de support…',
  'support.loading.thread': 'Chargement de la conversation…',
  'support.error.required': 'Saisissez un objet et un message.',
  'support.error.noBusiness': 'Sélectionnez une entreprise avant de contacter le support.',
  'support.error.create': 'La demande de support n\'a pas pu être envoyée. Réessayez.',
  'support.error.list': 'Impossible de charger les demandes de support.',
  'support.error.thread': 'Impossible de charger la conversation.',
  'support.error.reply': 'Le message n\'a pas pu être envoyé. Réessayez.',
  'support.error.status': 'Impossible de mettre à jour le statut.',
  'support.error.link': 'Saisissez un lien http:// ou https:// valide.',
  'support.error.imageType': 'Utilisez des images au format JPEG, PNG, GIF ou WebP.',
  'support.error.imageSourceSize': 'Chaque image d\'origine doit faire 20 MB au maximum.',
  'support.error.imageSourceTotal': 'Les images d\'origine ne doivent pas dépasser 40 MB au total par sélection.',
  'support.error.imageCount': 'Vous pouvez joindre jusqu\'à quatre images.',
  'support.error.imageSize': 'Une image dépasse encore 5 MB après optimisation.',
  'support.error.imageTotal': 'Les images optimisées ne doivent pas dépasser 10 MB au total par message.',
  'support.error.imageOptimize': 'L\'image n\'a pas pu être optimisée. Essayez une image plus petite.',
  'support.error.screenshot': 'La capture d\'écran n\'a pas pu être effectuée. Réessayez ou joignez une image manuellement.',
  'support.error.imagesUnavailable': 'L\'envoi d\'images nécessite la version mise à jour du service de support. Rechargez la page et réessayez.',
  'support.error.requestTimedOut': 'Le service de support n\'a pas répondu. Réessayez.',
  'support.page.tickets': 'Demandes',
  'support.page.articles': 'Articles',
  'support.articles.back': 'Retour aux articles',
  'support.articles.search.label': 'Rechercher dans les articles d\'aide',
  'support.articles.categories': 'Catégories',
  'support.articles.results': 'Articles trouvés : {count}',
  'support.articles.empty.title': 'Aucun article trouvé',
  'support.articles.empty.text': 'Essayez un autre terme de recherche ou choisissez une autre catégorie.',
  'support.articles.clear': 'Réinitialiser la recherche et le filtre',
  'support.pages.label': 'Choisir la page de support',
  'support.articles.search.placeholder': 'Rechercher dans les articles d\'aide',
  'support.articles.count.one': '{count} article',
  'support.articles.count.other': '{count} articles',
  'support.articles.resultsTitle': 'Résultats de recherche',
  'err.nativeValidation.backend-support.1': 'Réponse invalide lors de la suppression de la demande de support.',
});
